import { TypeResponse } from 'gtd-ng-widget';
import { OFFER_PRIVACY } from '../../../../../core/services/data/data-service.interface';

export class ProfileResponse extends TypeResponse {
  id: number;
  name: string;
  description: string;
  description_preset_description: string;
  description_preset_id: number;
  note: string;
  vertical: string;
  trackingDomain: { id: number; content: string } | null;
  conversion_type: string;
  is_private: boolean;
  advertiser: {
    name: string;
    id: string;
  };
  status: number;
  created_at: number;
  updated_at: number;
  affiliate_offer_tracking_domain: any;
  conversion_tracking_type: number;
  click_session_lifespan: number;
  is_white: boolean;
  advertiser_brand: { id: number; name: string };
  country_codes: string[];
  language_codes: string[];
  category: string;
  traffic_source: string;
  trafficback_url: string;
  redirect_type: string;
  privacy: OFFER_PRIVACY;
  currency_code: string;
}
